import { Row, Col, Input, Form, Card, Button, Divider, Icon } from 'antd';
import { AfspReact } from '@bit/ui-common.ui-components/afsp';
import tsaLogo from '@bit/ui-common.ui-components/afsp/images/dhs-logo-01.png';
import userIcon from  '@bit/ui-common.ui-components/afsp/images/user-icon-01.png';
import PasswordResetIndicator from 'components/login/PasswordResetIndicator';
import PasswordRequirementsIndicator from './PasswordRequirementsIndicator';
import AfspForgotPasswordForm from '@bit/ui-common.ui-components/afsp/react/components/login/forms/AfspForgotPasswordForm';
import * as config from '@bit/ui-common.ui-components/afsp/react/components/login/forms/formConfig';


import { ssFormUtils, ssFormValidationUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ generateInitState, meetsRequirements } = ssFormUtils,
{ validationRules } = ssFormValidationUtils,
{ isMinLength, hasNumericCharacter, hasLowerCharacter, hasUpperCharacter, hasSpecialCharacters } = validationRules,
layout = {
    size: {
        header: 'xs',
        footer: 'xs'
    },
    images: {
        logo: tsaLogo,
        user: userIcon
    },
    controlType: 'home',
    bgc: '#e6e6e6'
};

export default class ResetPassword extends React.Component {
    state = {
        buttonType: 'default',
        passwordType1: 'password',
        passwordType2: 'password',
        inputDisabled1: false,
        inputDisabled2: false,
        submitDisabled: false,
        passwordIcon1: 'eye-o',
        passwordIcon2: 'eye-o',
        passwordRequirementsMet: null,
        formStyle: {
            boxShadow: 'rgb(184, 184, 184) 0px 0px 20px',
            borderRadius: '10px',
            borderStyle: 'solid',
            borderColor: 'rgb(200, 200, 200)',
            borderWidth: '1px',
            filter: '',
            margin: '20px'
        },
        passwordFormProps1: {
            hasFeedback: false,
            required: true,
            help: '',
            validateStatus: '',
            label: 'New Password'
        },
        passwordFormProps2: {
            hasFeedback: false,
            required: true,
            help: '',
            validateStatus: '',
            label: 'Re-Type New Password'
        }
    }

    constructor(props) {
        super(props);
        this.initFormState();
    }

    initFormState() {
        let formConfig = {...config};
        const { services, state: { registrationForm }} = this.props;
        delete formConfig.linkedFormFields;
        for(let f in formConfig) {
            let config = formConfig[f];
            if(!registrationForm[config.key])
                services.storeForm(config.key, generateInitState(config));
        }
    }

    toggleButtonType = () => this.setState({...this.state, buttonType: this.state.buttonType === 'default' ? 'primary' : 'default' });
    togglePasswordType = (t, i) => this.setState({...this.state,
        [t]: this.state[t] === 'password' ? 'text' : 'password',
        [i]: this.state[i] === 'eye-o' ? 'eye' : 'eye-o'
    });

    toggleHandleSubmit = returnState => {
        returnState = !!returnState;
        if(returnState) return {...this.state,
            formStyle: {...this.state.formStyle, filter: this.state.formStyle.filter === '' ? 'blur(8px) grayscale(100%)' : '' },
            inputDisabled1: !this.state.inputDisabled1,
            inputDisabled2: !this.state.inputDisabled2,
            submitDisabled: !this.state.submitDisabled
        }
        else {
            this.setState({...this.state,
                formStyle: {...this.state.formStyle, filter: this.state.formStyle.filter === '' ? 'blur(8px) grayscale(100%)' : '' },
                inputDisabled1: !this.state.inputDisabled1,
                inputDisabled2: !this.state.inputDisabled2,
                submitDisabled: !this.state.submitDisabled
            });
        }
    }

    updateFormProps = (value, name, props) => {
        let reqs = null, secondary = '', primaryProps = null, secondaryProps = null;

        const
        primary = value,
        passwordMatch = (
            <div>
                <div style={{ position: 'absolute', right: '22px', top: '13px' }}>
                    <Icon type='check-circle' style={{ color: 'rgb(82, 196, 26)' }} />
                </div>
                <div style={{ marginBottom: '12px' }}></div>
            </div>
        ),
        passwordRequirements = p => {
            if(reqs != null && !reqs) {
                p.help = 'Requirements not met.';
                p.validateStatus = 'error';
            }
            return p;
        };

        switch(name) {
            case 'newPassword1':
                secondary = this.props.state.passwordReset.newPassword2.password;
                primaryProps = props.passwordFormProps1;
                secondaryProps = props.passwordFormProps2;
                break;
            case 'newPassword2':
                secondary = this.props.state.passwordReset.newPassword1.password;
                primaryProps = props.passwordFormProps2;
                secondaryProps = props.passwordFormProps1;
                break;
        }

        if(primary.length > 0) {
            reqs = meetsRequirements(name === 'newPassword1' ? primary : secondary, [
                hasUpperCharacter,
                hasLowerCharacter,
                hasNumericCharacter,
                hasSpecialCharacters,
                isMinLength('12')
            ]);

            if(primary === secondary) {
                primaryProps.help = passwordMatch;
                primaryProps.validateStatus = 'success';
                secondaryProps.help = passwordMatch;
                secondaryProps.validateStatus = 'success';
            } else {
                primaryProps.help = 'Password does not match.';
                primaryProps.validateStatus = 'warning';
            }
        } else {
            primaryProps.help = '';
            primaryProps.validateStatus = '';
            if(secondary.length === 0) {
                secondaryProps.help = '';
                secondaryProps.validateStatus = '';
            } else {
                secondaryProps.help = 'Password does not match.';
                secondaryProps.validateStatus = 'warning';
            }
        }

        this.setState({...this.state,
            passwordRequirementsMet: primary.length > 0 ? reqs : null,
            passwordFormProps1: passwordRequirements(primaryProps.label === props.passwordFormProps1.label ? primaryProps : secondaryProps),
            passwordFormProps2: primaryProps.label === props.passwordFormProps2.label ? primaryProps : secondaryProps
        });
    }

    resetStateData = newState => this.setState({...newState,
        buttonType: 'default',
        passwordFormProps1: {...newState.passwordFormProps1, validateStatus: '', help: '' },
        passwordFormProps2: {...newState.passwordFormProps2, validateStatus: '', help: '' }
    });

    componentDidMount() {
        this.props.services.checkExpiredToken( this.props.token);
    }

    render() {
        const
        s = this.state,
        { services, state, token } = this.props,
        { newPassword1, newPassword2 } = state.passwordReset,
        formProps = { passwordFormProps1: s.passwordFormProps1, passwordFormProps2: s.passwordFormProps2 };

        return (
            <div>
                {state.passwordReset.checkTokenRequest.status === 'failure' &&
                <AfspReact.Layout {...layout}>
                    <div style={{
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                        top: '50%',
                        left: '50%',
                        overflow: 'auto'
                    }}>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col span={23}>
                                <div style={s.formStyle}>
                                    <Card style={{
                                        borderRadius: '10px',
                                        borderStyle: 'solid',
                                        borderColor: 'rgb(255, 255, 255)',
                                        borderWidth: '1px'
                                    }}>
                                        <Row type='flex' justify='space-around' align='middle'>
                                            <Col>
                                                <div style={{ width: '300px' }}>
                                                    <div style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '4px' }}>
                                                        {'Invalid Password Reset Link'}
                                                    </div>
                                                    <div style={{ fontStyle: 'italic' }}>
                                                        {'Your password reset link has expired or is not valid, please request a new password reset link'}
                                                    </div>
                                                    <Divider type='horizontal' />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row type='flex' justify='space-around' align='middle'>
                                            <Col style={{ textAlign: 'right', width: '314px' }}>
                                                <Button
                                                    size='small'
                                                    type={this.state.buttonType}
                                                    style={{ width: '240px', borderRadius: '20px' }}
                                                    onMouseOver={() => this.toggleButtonType()}
                                                    onMouseOut={() => this.toggleButtonType()}
                                                    onClick={() => services.toggleAfspPasswordResetModal('forgot-password')}
                                                >
                                                    Request New Password Reset Link
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <AfspForgotPasswordForm {...this.props} />
                                        </Row>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                        </div>
                    </AfspReact.Layout>
                }

                {state.passwordReset.checkTokenRequest.status === 'success' &&
                <AfspReact.Layout {...layout}>
                    <div style={{
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                        top: '50%',
                        left: '50%',
                        overflow: 'auto'
                    }}>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col span={23}>
                                <div style={s.formStyle}>
                                    <Card style={{
                                        borderRadius: '10px',
                                        borderStyle: 'solid',
                                        borderColor: 'rgb(255, 255, 255)',
                                        borderWidth: '1px'
                                    }}>
                                        <Row type='flex' justify='space-around' align='middle'>
                                            <Col>
                                                <div style={{ width: '300px' }}>
                                                    <div style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '4px' }}>
                                                        {'Password Reset'}
                                                    </div>
                                                    <div style={{ fontStyle: 'italic' }}>
                                                        {'Please reset your FTSP log-in password.'}
                                                    </div>
                                                    <Divider type='horizontal' />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row type='flex' justify='space-around' align='middle'>
                                            <Col>
                                                <Form.Item {...s.passwordFormProps1} style={{ width: '300px' }}>
                                                    <PasswordRequirementsIndicator requirementsMet={s.passwordRequirementsMet}>
                                                        <Input
                                                            size='small'
                                                            type={this.state.passwordType1}
                                                            placeholder='New Password'
                                                            autocomplete='off'
                                                            disabled={s.inputDisabled1}
                                                            prefix={(<Icon type='lock' />)}
                                                            suffix={(<Icon type={this.state.passwordIcon1}
                                                                onClick={() => this.togglePasswordType('passwordType1', 'passwordIcon1')}
                                                            />)}
                                                            onChange={e => {
                                                                this.updateFormProps(e.target.value, e.target.name, {...formProps});
                                                                services.updateResetField('newPassword1', e.target.value);
                                                            }}
                                                            value={newPassword1.password}
                                                            name='newPassword1'
                                                        />
                                                    </PasswordRequirementsIndicator>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                                            <Col>
                                                <Form.Item {...s.passwordFormProps2}  style={{ width: '300px' }}>
                                                    <Input
                                                        size='small'
                                                        type={this.state.passwordType2}
                                                        placeholder='Re-Type New Password'
                                                        disabled={s.inputDisabled2}
                                                        autocomplete='off'
                                                        prefix={(<Icon type='lock' />)}
                                                        suffix={(<Icon type={this.state.passwordIcon2}
                                                            onClick={() => this.togglePasswordType('passwordType2', 'passwordIcon2')}
                                                        />)}
                                                        onChange={e => {
                                                            this.updateFormProps(e.target.value, e.target.name, {...formProps});
                                                            services.updateResetField('newPassword2', e.target.value);
                                                        }}
                                                        value={newPassword2.password}
                                                        name='newPassword2'
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row type='flex' justify='space-around' align='middle'>
                                            <Col style={{ textAlign: 'right', width: '314px' }}>
                                                <Button
                                                    size='small'
                                                    icon='check-circle-o'
                                                    type={this.state.buttonType}
                                                    disabled={newPassword1.password.length > 0 && newPassword2.password.length > 0 ? s.submitDisabled : true}
                                                    disabled={s.submitDisabled}
                                                    style={{ width: '160px', borderRadius: '20px' }}
                                                    onMouseOver={() => this.toggleButtonType()}
                                                    onMouseOut={() => this.toggleButtonType()}
                                                    onClick={() => {
                                                        this.toggleHandleSubmit();
                                                        services.togglePasswordResetModal();
                                                        services.updateNewPassword(token, newPassword1.password);
                                                    }}
                                                >
                                                    {'Change Password'}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <PasswordResetIndicator {...this.props}
                        type='reset-password'
                        toggleHandleSubmit={() => {
                            services.updateResetField('newPassword1', '');
                            services.updateResetField('newPassword2', '');
                            this.resetStateData(this.toggleHandleSubmit(true));
                        }}
                    />
                </AfspReact.Layout>
                }
            </div>
        );
    }
}
